// extracted by mini-css-extract-plugin
export default {"page":"LegalLayout_page__JGOyg","container":"LegalLayout_container__HQnk-"};